import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import Outlet from 'components/navigation/Outlet';
import * as PageOutlets from 'components/pages';

export default function PageOutlet(props) {
  const {
    renderAll = false,
    front,
    inert,
    category,
    pages,
    ...rest
  } = props;
  return (
    <Outlet
      {...ex(['PageOutlet', { renderAll }], rest)}
      {...{
        renderAll,
        inert,
        category,
        pages: [...pages],
        outlets: { ...PageOutlets },
        front,
      }}
    />
  );
}
